module.exports = "{{#if filterView}}<span class=\"js-filter-btn filter-sort-btn\"></span>{{/if}} <div class=js-cell-content style=display:inline> {{displayText}} {{#if sortingAsc}}<span class=sort_down></span>{{/if}} {{#if sortingDesc}}<span class=sort_up></span>{{/if}} </div> ";


//////////////////
// WEBPACK FOOTER
// ../src/nativeGrid/templates/columnHeader.hbs
// module id = 712
// module chunks = 0